var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import subProjectService from '../../services/subProjectService';
import { Alert, Button, Card, DatePicker, Descriptions, Divider, Flex, Form, Input, InputNumber, message, Select, Skeleton, Space, Spin, Table, Tabs, Typography, Upload } from 'antd';
import dayjs from 'dayjs';
import { CommentOutlined, InboxOutlined, UndoOutlined, UploadOutlined } from '@ant-design/icons';
import TextArea from 'antd/es/input/TextArea';
import { DownloadDocument, formatDate, formatDateDisplay } from '../../utils/commonUtil';
import certificateService from '../../services/certificateService';
import '../../styles/subProject.css';
import ProductFamilyModal from '../../components/certificate/productFamilyModal';
import DocComments from '../../components/subProject/docComments';
import DocRevised from '../../components/subProject/docRevised';
import ShareComments from '../../components/subProject/shareComments';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import CertComments from '../../components/subProject/certComments';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import commonService from "../../services/CommonService";
import { UserActivity } from "../../config/BVConstants";
const SubProjectDetail = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24;
    const [objWorkOrder, setObjWorkOrder] = useState({});
    const [form] = Form.useForm();
    const [selectedDocRowKeys, setSelectedDocRowKeys] = useState([]);
    const [selectedDownloadRowKeys, setSelectedDownloadRowKeys] = useState([]);
    const [selectedUploadRowKeys, setSelectedUploadRowKeys] = useState([]);
    const [selectedInvoiceRowKeys, setSelectedInvoiceRowKeys] = useState([]);
    const customFormat = (value) => `${value.format('DD-MM-YYYY')}`;
    const [fileList, setFileList] = useState([]);
    const inputStyle = { width: '130px' };
    const [boolDisableVenAssStatus, setBoolDisableVenAssStatus] = useState(false);
    const [boolDisableWoDocsBtn, setBoolDisableWoDocsBtn] = useState(false);
    const [showFactoryRemark, setshowFactoryRemark] = useState(false);
    const [openProdFamilyDialog, setOpenProdFamilyDialog] = useState(false);
    const [productFamilyList, setProductFamilyList] = useState([]);
    const [docRecord, setDocRecord] = useState();
    const [docQuestion, setDocQuestion] = useState();
    const [openDocCommentDialog, setOpenDocCommentDialog] = useState(false);
    const [lstDocumentComments, setLstDocumentComments] = useState([]);
    const [docPrevRecord, setDocPrevRecord] = useState();
    const [openDocPreviousDialog, setOpenDocPreviousDialog] = useState(false);
    const [lstPrevVersionDocs, setLstPrevVersionDocs] = useState([]);
    const [bvQuestion, setBVQuestion] = useState();
    const [openBVCommentDialog, setOpenBVCommentDialog] = useState(false);
    const [loading, setLoading] = React.useState(false);
    const [downAllloading, setDownAllloading] = React.useState(false);
    const applicationData = useSelector((state) => state.applicationData);
    const [loadingDesc, setLoadingDesc] = useState(true);
    const { subProjectId } = useParams();
    const [openCertUpdateModal, setOpenCertUpdateModal] = useState(false);
    const [lstCertDocumentComments, setLstCertDocumentComments] = useState([]);
    const [loadingVendorDoc, setLoadingVendorDoc] = useState(false);
    const objSampleStatus = applicationData.vendorSampleList.map((obj) => ({
        label: obj.strLongDesc,
        value: obj.intId
    }));
    const optCurrency = applicationData.vendorCurrencyList.map((obj) => ({
        label: obj.strShortDesc + '-' + obj.strLongDesc,
        value: obj.intId
    }));
    useEffect(() => {
        var _a, _b, _c, _d;
        if ((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId) {
            commonService
                .logUserActivity((_d = (_c = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _c === void 0 ? void 0 : _c.userLoginDetails) === null || _d === void 0 ? void 0 : _d.strUserEmailId, UserActivity.VP__Sub_Project_Detail_Visited);
        }
    }, [(_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId]);
    useEffect(() => {
        const objSearchWORequest = {
            strWorkorderId: atob(subProjectId ? subProjectId : ''),
            intVendorId: applicationData.loggedInClient.userLoginDetails.intCompanyID
        };
        subProjectService.getSubProjectDetails(objSearchWORequest).then((res) => {
            setLoadingDesc(false);
            directCertManipulate(res).then((data) => {
            });
        });
    }, []);
    function directCertManipulate(certData) {
        return __awaiter(this, void 0, void 0, function* () {
            setObjWorkOrder(certData);
            let objLuSampleStatus;
            if (certData === null || certData === void 0 ? void 0 : certData.objLuSampleStatus) {
                objLuSampleStatus = { intId: 1117, strLongDesc: 'Received by Vendor' };
            }
            else {
                objLuSampleStatus = { intId: 1115, strLongDesc: 'Waiting for Sample' };
            }
            let lstMpWoVendor = [];
            if (certData === null || certData === void 0 ? void 0 : certData.lstMpWoVendor) {
                lstMpWoVendor = certData === null || certData === void 0 ? void 0 : certData.lstMpWoVendor.map((item, index) => {
                    if ((item === null || item === void 0 ? void 0 : item.agentAssigntmentStatus) === 8002 || (item === null || item === void 0 ? void 0 : item.agentAssigntmentStatus) === 8004) {
                        setBoolDisableVenAssStatus(false);
                    }
                    return {
                        dtVendorAssignedDate: (item === null || item === void 0 ? void 0 : item.dtVendorAssignedDate)
                            ? dayjs(item === null || item === void 0 ? void 0 : item.dtVendorAssignedDate, 'DD/MM/YYYY HH:mm:ss')
                            : null,
                        dtVendorPlannedCompDate: (item === null || item === void 0 ? void 0 : item.dtVendorPlannedCompDate)
                            ? dayjs(item === null || item === void 0 ? void 0 : item.dtVendorPlannedCompDate, 'DD/MM/YYYY HH:mm:ss')
                            : null,
                        dtExpCompletionDate: (item === null || item === void 0 ? void 0 : item.dtExpCompletionDate)
                            ? dayjs(item === null || item === void 0 ? void 0 : item.dtExpCompletionDate, 'DD/MM/YYYY HH:mm:ss')
                            : null,
                        dtStartDate: (item === null || item === void 0 ? void 0 : item.dtStartDate) ? dayjs(item === null || item === void 0 ? void 0 : item.dtStartDate, 'DD/MM/YYYY HH:mm:ss') : null,
                        dtAssignedDate: (item === null || item === void 0 ? void 0 : item.dtAssignedDate)
                            ? dayjs(item === null || item === void 0 ? void 0 : item.dtAssignedDate, 'DD/MM/YYYY HH:mm:ss')
                            : null
                    };
                });
            }
            let certList = [];
            if (certData === null || certData === void 0 ? void 0 : certData.lstMpWoVendorCert) {
                certList = certData === null || certData === void 0 ? void 0 : certData.lstMpWoVendorCert.map((item, index) => {
                    var _a;
                    return (Object.assign(Object.assign({}, item), { dtCertDate: (item === null || item === void 0 ? void 0 : item.dtCertDate) ? dayjs(item === null || item === void 0 ? void 0 : item.dtCertDate, 'DD/MM/YYYY HH:mm:ss') : null, dtCertExpirationDate: (item === null || item === void 0 ? void 0 : item.dtCertExpirationDate)
                            ? dayjs(item === null || item === void 0 ? void 0 : item.dtCertExpirationDate, 'DD/MM/YYYY HH:mm:ss')
                            : null, dtCreatedDate: (item === null || item === void 0 ? void 0 : item.dtCreatedDate)
                            ? dayjs(item === null || item === void 0 ? void 0 : item.dtCreatedDate, 'DD/MM/YYYY HH:mm:ss')
                            : null, objCertStatus: ((_a = item === null || item === void 0 ? void 0 : item.objLuCertVerification) === null || _a === void 0 ? void 0 : _a.intId) === 1806 ? item === null || item === void 0 ? void 0 : item.objCertStatus : null, certUpload: (item === null || item === void 0 ? void 0 : item.strDocName)
                            ? [
                                {
                                    uid: item === null || item === void 0 ? void 0 : item.strDocRefId,
                                    isDocRefId: true,
                                    name: item === null || item === void 0 ? void 0 : item.strDocName,
                                    status: 'done'
                                }
                            ]
                            : null }));
                });
            }
            let certInvoiceList = [];
            if (certData === null || certData === void 0 ? void 0 : certData.lstMpWoVendorInvoice) {
                certInvoiceList = certData === null || certData === void 0 ? void 0 : certData.lstMpWoVendorInvoice.map((item, index) => (Object.assign(Object.assign({}, item), { key: index, dtCreatedDate: (item === null || item === void 0 ? void 0 : item.dtCreatedDate)
                        ? dayjs(item === null || item === void 0 ? void 0 : item.dtCreatedDate, 'DD/MM/YYYY HH:mm:ss')
                        : null, dtInvoiceDueDate: (item === null || item === void 0 ? void 0 : item.dtInvoiceDueDate)
                        ? dayjs(item === null || item === void 0 ? void 0 : item.dtInvoiceDueDate, 'DD/MM/YYYY HH:mm:ss')
                        : null, dtReceivedDate: (item === null || item === void 0 ? void 0 : item.dtReceivedDate)
                        ? dayjs(item === null || item === void 0 ? void 0 : item.dtReceivedDate, 'DD/MM/YYYY HH:mm:ss')
                        : null, invoiceUpload: [
                        {
                            uid: item === null || item === void 0 ? void 0 : item.strDocRefId,
                            isDocRefId: true,
                            name: item === null || item === void 0 ? void 0 : item.strDocName,
                            status: 'done'
                        }
                    ] })));
            }
            let lstVendorUploadDocs = [];
            if (certData === null || certData === void 0 ? void 0 : certData.lstVendorUploadDocs) {
                lstVendorUploadDocs = certData === null || certData === void 0 ? void 0 : certData.lstVendorUploadDocs.map((item, index) => (Object.assign(Object.assign({}, item), { dtSubmittedDate: (item === null || item === void 0 ? void 0 : item.dtUploadedDate)
                        ? dayjs(item === null || item === void 0 ? void 0 : item.dtUploadedDate, 'DD/MM/YYYY HH:mm:ss')
                        : null, vendorDocs: [
                        {
                            uid: item === null || item === void 0 ? void 0 : item.strDocRefId,
                            isDocRefId: true,
                            name: item === null || item === void 0 ? void 0 : item.strDocName,
                            status: 'done'
                        }
                    ] })));
            }
            const objMpWoVendor = lstMpWoVendor && lstMpWoVendor.length > 0 ? lstMpWoVendor[0] : null;
            const objWoFields = {
                dtVendorAssignedDate: (objMpWoVendor === null || objMpWoVendor === void 0 ? void 0 : objMpWoVendor.dtVendorAssignedDate)
                    ? dayjs(objMpWoVendor === null || objMpWoVendor === void 0 ? void 0 : objMpWoVendor.dtVendorAssignedDate, 'DD/MM/YYYY HH:mm:ss')
                    : null,
                dtVendorPlannedCompDate: (objMpWoVendor === null || objMpWoVendor === void 0 ? void 0 : objMpWoVendor.dtVendorPlannedCompDate)
                    ? dayjs(objMpWoVendor === null || objMpWoVendor === void 0 ? void 0 : objMpWoVendor.dtVendorPlannedCompDate, 'DD/MM/YYYY HH:mm:ss')
                    : null,
                dtExpCompletionDate: (objMpWoVendor === null || objMpWoVendor === void 0 ? void 0 : objMpWoVendor.dtExpCompletionDate)
                    ? dayjs(objMpWoVendor === null || objMpWoVendor === void 0 ? void 0 : objMpWoVendor.dtExpCompletionDate, 'DD/MM/YYYY HH:mm:ss')
                    : null,
                dtSampleReceivedDate: (certData === null || certData === void 0 ? void 0 : certData.dtSampleReceivedDate)
                    ? dayjs(certData === null || certData === void 0 ? void 0 : certData.dtSampleReceivedDate, 'DD/MM/YYYY HH:mm:ss')
                    : null,
                objLuSampleStatus: objLuSampleStatus,
                lstMpWoVendorCert: certList,
                lstMpWoVendorInvoice: certInvoiceList,
                lstVendorUploadDocs: lstVendorUploadDocs
            };
            form.setFieldsValue(objWoFields);
            if (certData === null || certData === void 0 ? void 0 : certData.lstAttachements) {
                var lstEEDocumentDownload = certData === null || certData === void 0 ? void 0 : certData.lstAttachements;
                const lstAttachements = certData === null || certData === void 0 ? void 0 : certData.lstAttachements.map((item, index) => __awaiter(this, void 0, void 0, function* () {
                    var _a;
                    var boolDisableDocRow;
                    if (((_a = item === null || item === void 0 ? void 0 : item.objDocumentStatus) === null || _a === void 0 ? void 0 : _a.intId) === 1124 && !(item === null || item === void 0 ? void 0 : item.intResponseType)) {
                        boolDisableDocRow = false;
                        setBoolDisableWoDocsBtn(true);
                    }
                    else if ((item === null || item === void 0 ? void 0 : item.intResponseType) === 1 || (item === null || item === void 0 ? void 0 : item.intResponseType) === 0) {
                        boolDisableDocRow = true;
                    }
                    else {
                        boolDisableDocRow = true;
                    }
                    if (item.boolRevisedVersion) {
                        subProjectService.getLstRevisedDocs(item).then((res) => {
                            lstEEDocumentDownload.push(...res);
                        });
                    }
                    return Object.assign(Object.assign({}, item), { boolDisableDocRow: boolDisableDocRow });
                }));
                var lstAttach = yield Promise.all(lstAttachements);
            }
            setObjWorkOrder((prevObjWorkOrder) => (Object.assign(Object.assign({}, prevObjWorkOrder), { dtExpCompletionDate: (objMpWoVendor === null || objMpWoVendor === void 0 ? void 0 : objMpWoVendor.dtExpCompletionDate)
                    ? dayjs(objMpWoVendor === null || objMpWoVendor === void 0 ? void 0 : objMpWoVendor.dtExpCompletionDate, 'DD/MM/YYYY HH:mm:ss')
                    : null, ['lstAttachements']: lstAttach, ['lstEEDocumentDownload']: lstEEDocumentDownload })));
            return certData;
        });
    }
    const loadingItems = [];
    const skeletonItem = {
        label: _jsx(Skeleton.Input, { active: true, size: 'small' }),
        children: _jsx(Skeleton.Input, { active: true, size: 'small' }),
        span: { xl: 2, xxl: 2 }
    };
    for (let i = 0; i < 6; i++) {
        loadingItems.push(skeletonItem);
    }
    const handleProdFamilyDialog = () => {
        certificateService.getCertProductFamily(objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.strUniqueId).then((res) => {
            // Adjust the type of 'res' according to your API response
            for (const prod of res) {
                if (prod.strRemarks) {
                    setshowFactoryRemark(true);
                }
            }
            setProductFamilyList(res);
        });
        setOpenProdFamilyDialog(true);
    };
    const onSelectChange = (name, selectedRowKeys) => {
        if (name === 'vendorUpload') {
            setSelectedUploadRowKeys(selectedRowKeys);
        }
        else if (name === 'acceptDocAttachment') {
            setSelectedDocRowKeys(selectedRowKeys);
        }
        else if (name === 'downloadAttachment') {
            setSelectedDownloadRowKeys(selectedRowKeys);
        }
        else if (name === 'invoiceInfo') {
            setSelectedInvoiceRowKeys(selectedRowKeys);
        }
    };
    const subProjectInfo = [
        {
            key: '1',
            label: 'Sub Project No.',
            children: objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.strWorkOrderId,
            span: 2,
            style: { width: '25%' }
        },
        {
            key: '2',
            label: 'Risk Status',
            children: (objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.intRiskStatus) === 1 ? 'Project on Schedule' : 'Project on Risk',
            span: 2,
            style: { width: '25%' }
        },
        {
            key: '3',
            label: 'Entity Company Name',
            children: (_e = (_d = (_c = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objEEMaster) === null || _c === void 0 ? void 0 : _c.objClientMaster) === null || _d === void 0 ? void 0 : _d.objLuCompany) === null || _e === void 0 ? void 0 : _e.strLongDesc,
            span: 2,
            style: { width: '25%' }
        },
        {
            key: '4',
            label: 'Sub Project Type',
            children: (_g = (_f = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objTblService) === null || _f === void 0 ? void 0 : _f.objLuRequestType) === null || _g === void 0 ? void 0 : _g.strLongDesc,
            span: 2,
            style: { width: '25%' }
        },
        {
            key: '5',
            label: 'Sub Project Status',
            children: (_h = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objLuWorkOrderStatus) === null || _h === void 0 ? void 0 : _h.strLongDesc,
            span: 2,
            style: { width: '25%' }
        },
        {
            key: '6',
            label: 'Document Completion',
            children: parseFloat((_j = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objEEDocument) === null || _j === void 0 ? void 0 : _j.dbWoDocsCompCount).toFixed(2) + '%',
            span: 2,
            style: { width: '25%' }
        }
    ];
    const serviceProductInfo = [
        {
            key: '1',
            label: 'Certificate Name',
            children: (_k = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objTblService) === null || _k === void 0 ? void 0 : _k.strServiceName,
            span: 2,
            style: { width: '25%' }
        },
        {
            key: '2',
            label: 'Technology',
            children: (_m = (_l = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objEEMaster) === null || _l === void 0 ? void 0 : _l.objLuTechnologyType) === null || _m === void 0 ? void 0 : _m.strLongDesc,
            span: 2,
            style: { width: '25%' }
        },
        {
            key: '3',
            label: 'Country/Territory',
            children: (_p = (_o = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objTblService) === null || _o === void 0 ? void 0 : _o.objLuCountry) === null || _p === void 0 ? void 0 : _p.strLongDesc,
            span: 2,
            style: { width: '25%' }
        },
        {
            key: '4',
            label: 'Product Name',
            children: (_q = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objEEMaster) === null || _q === void 0 ? void 0 : _q.strProductNameEN,
            span: 2,
            style: { width: '25%' }
        },
        {
            key: '5',
            label: 'Service Type',
            children: (_s = (_r = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objTblService) === null || _r === void 0 ? void 0 : _r.objLuServiceCode) === null || _s === void 0 ? void 0 : _s.strLongDesc,
            span: 2,
            style: { width: '25%' }
        },
        {
            key: '6',
            label: 'Product Model',
            children: (_t = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objEEMaster) === null || _t === void 0 ? void 0 : _t.strPrimaryModel,
            span: 2,
            style: { width: '25%' }
        },
        {
            key: '7',
            label: 'Product Category',
            children: (_v = (_u = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objEEMaster) === null || _u === void 0 ? void 0 : _u.objLuProductType) === null || _v === void 0 ? void 0 : _v.strLongDesc,
            span: 2,
            style: { width: '25%' }
        },
        {
            key: '8',
            label: 'Brand/OEM',
            children: ((_w = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objEEMaster) === null || _w === void 0 ? void 0 : _w.boolProductFamily) ? (_jsx(Typography.Link, { strong: true, onClick: () => handleProdFamilyDialog(), children: (_y = (_x = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objEEMaster) === null || _x === void 0 ? void 0 : _x.objBrandName) === null || _y === void 0 ? void 0 : _y.strLongDesc })) : ((_0 = (_z = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objEEMaster) === null || _z === void 0 ? void 0 : _z.objBrandName) === null || _0 === void 0 ? void 0 : _0.strLongDesc),
            span: 2,
            style: { width: '25%' }
        },
        {
            key: '9',
            label: 'Product Sub Segment',
            children: (_2 = (_1 = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objEEMaster) === null || _1 === void 0 ? void 0 : _1.objLuProductMainType) === null || _2 === void 0 ? void 0 : _2.strLongDesc,
            span: 2,
            style: { width: '25%' }
        }
    ];
    const prjScheduleInfo = [
        {
            key: '1',
            label: 'BV Sub Project Assigned Start Date',
            children: formatDateDisplay(objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.dtStartDate),
            span: 2,
            style: { width: '25%' }
        },
        {
            key: '2',
            label: 'Vendor Start Date',
            children: (_jsx(Form.Item, { name: 'dtVendorAssignedDate', rules: [
                    {
                        required: true
                    }
                ], children: _jsx(DatePicker
                // style={{ width: 250 }}
                , { 
                    // style={{ width: 250 }}
                    format: customFormat, multiple: false, disabled: ((_3 = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objLuWorkOrderStatus) === null || _3 === void 0 ? void 0 : _3.intId) === 4003 && !boolDisableVenAssStatus, minDate: dayjs(objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.dtStartDate, 'DD-MM-YYYY') }) })),
            span: 2,
            style: { width: '25%' }
        },
        {
            key: '3',
            label: 'BV Planned Completion Date',
            children: formatDateDisplay(objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.dtExpCompletionDate),
            span: 2,
            style: { width: '25%' }
        },
        {
            key: '4',
            label: 'Vendor Completion Date',
            children: (_jsx(Form.Item, { name: 'dtVendorPlannedCompDate', rules: [
                    {
                        required: true
                    }
                ], children: _jsx(DatePicker
                // style={{ width: 250 }}
                , { 
                    // style={{ width: 250 }}
                    format: customFormat, multiple: false, disabled: ((_4 = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objLuWorkOrderStatus) === null || _4 === void 0 ? void 0 : _4.intId) === 4003 && !boolDisableVenAssStatus, minDate: dayjs(form.getFieldValue('dtVendorAssignedDate'), 'DD-MM-YYYY') }) })),
            span: 2,
            style: { width: '25%' }
        },
        {
            key: '5',
            label: 'Actual Completion Date',
            children: formatDateDisplay(objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.dtCompletionDate),
            span: 2,
            style: { width: '25%' }
        }
    ];
    const sampleInfo = [
        {
            key: '1',
            label: 'Sample Status',
            children: (form.getFieldValue(['objLuSampleStatus', 'strLongDesc'])),
            // <Form.Item name={['objLuSampleStatus', 'intId']}>
            //   <Select
            //     disabled
            //     showSearch
            //     // style={{ width: 250 }}
            //     placeholder="Sample Status"
            //     options={objSampleStatus}
            //   />
            // </Form.Item>
            // ),
            span: 2,
            style: { width: '25%' }
        },
        {
            key: '2',
            label: 'Vendor Sample Received Date',
            children: (_jsx(Form.Item, { name: 'dtSampleReceivedDate', rules: [
                    {
                        required: objWorkOrder.intTestingApplicability === 1,
                        message: 'Vendor Sample Received Date is Required'
                    }
                ], children: _jsx(DatePicker
                // style={{ width: 250 }}
                , { 
                    // style={{ width: 250 }}
                    format: customFormat, multiple: false, disabled: ((_5 = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objLuWorkOrderStatus) === null || _5 === void 0 ? void 0 : _5.intId) === 4003 && !boolDisableVenAssStatus }) })),
            span: 2,
            style: { width: '25%' }
        }
    ];
    const sampleInfosColumns = [
        {
            title: 'S.No.',
            key: '1',
            render: (text, record, index) => index + 1
        },
        {
            title: 'Sample Condition',
            dataIndex: ['objLuSampleCondition', 'strLongDesc'],
            key: '2'
        },
        {
            title: 'Sample Size',
            dataIndex: 'intSampleSize',
            key: '3'
        }
    ];
    const vendorServiceRatingColumns = [
        {
            title: 'S.No.',
            render: (text, record, index) => index + 1
        },
        {
            title: 'Vendor Performing Rating',
            dataIndex: ['objLuVendorPerfRating', 'strLongDesc'],
            key: 'objLuVendorPerfRating'
        },
        {
            title: 'Project Complexity Rating',
            dataIndex: ['objLuProjectComplexityRating', 'strLongDesc'],
            key: 'objLuProjectComplexityRating'
        },
        {
            title: 'Difficulty Reason',
            dataIndex: 'lstDifficultyReasons',
            key: 'lstDifficultyReasons',
            render: (lstDifficultyReasons) => (_jsx("ul", { children: lstDifficultyReasons.map((value, index) => (_jsx("li", { children: value.strLongDesc }, index))) }))
        }
    ];
    const bvContactInfo = [
        {
            key: '1',
            label: 'Name',
            children: (_7 = (_6 = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objAssignedTo) === null || _6 === void 0 ? void 0 : _6.objUser) === null || _7 === void 0 ? void 0 : _7.strLongDesc,
            span: 2,
            style: { width: '25%' }
        },
        {
            key: '2',
            label: 'BV Location',
            children: (_9 = (_8 = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objEEMaster) === null || _8 === void 0 ? void 0 : _8.objBusinessUnit) === null || _9 === void 0 ? void 0 : _9.strBusinessUnitName,
            span: 2,
            style: { width: '25%' }
        },
        {
            key: '3',
            label: 'Email',
            children: (_11 = (_10 = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objAssignedTo) === null || _10 === void 0 ? void 0 : _10.objContact) === null || _11 === void 0 ? void 0 : _11.strEmailAddress,
            span: 2,
            style: { width: '25%' }
        }
    ];
    const getCommentsHistoryForDoc = (record) => {
        var _a;
        setLstDocumentComments([]);
        const objComment = {
            intVendorComapnyId: applicationData.loggedInClient.userLoginDetails.intCompanyID,
            intCommentLevelId: 4,
            intDocumentId: record.intDocId,
            intVersion: record.intVersion,
            strProjectId: record.boolGeneralDoc ? (_a = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objEEMaster) === null || _a === void 0 ? void 0 : _a.strProjectId : null,
            strWorkOrderId: record.boolGeneralDoc ? null : objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.strWorkOrderId
        };
        subProjectService.getVendorDocComments(objComment).then((res) => {
            setLstDocumentComments(res);
        });
        setDocQuestion('');
        setDocRecord(record);
        setOpenDocCommentDialog(true);
    };
    const getPreviousVersionDocs = (record, key) => {
        setDocPrevRecord(Object.assign({ key: key }, record));
        setOpenDocPreviousDialog(true);
        if (!record.boolRevisedVersion) {
            record['boolPreVersion'] = true;
        }
        if (record.boolGeneralDoc) {
            subProjectService.getPreviousVersionDocs(record).then((res) => {
                setLstPrevVersionDocs(res);
            });
        }
        else {
            subProjectService.getPrjCountrySpecPrevVerDocs(record).then((res) => {
                setLstPrevVersionDocs(res);
            });
        }
    };
    const getBVComments = () => {
        setBVQuestion('');
        setOpenBVCommentDialog(true);
        let objcmt = {};
        objcmt['workorderId'] = objWorkOrder.strWorkOrderId;
        objcmt['vendorId'] = applicationData.loggedInClient.userLoginDetails.intCompanyID + '';
        subProjectService.getComments(objcmt).then((res) => {
            setLstDocumentComments(res);
        });
    };
    const attachementsColumns = [
        {
            title: 'S.No.',
            render: (text, record, index) => index + 1
        },
        {
            title: 'Document Category',
            dataIndex: ['objLuDocumentCategory', 'strLongDesc'],
            key: 'objLuDocumentCategory'
        },
        {
            title: 'Document Type',
            dataIndex: ['objDocumentType', 'strLongDesc'],
            key: 'objDocumentType'
        },
        {
            title: 'Generic/Specific',
            dataIndex: 'boolGeneralDoc',
            key: 'boolGeneralDoc',
            render: (text, record) => (record.boolIsGeneralDoc ? 'Generic(Shared)' : 'Country/Territory Specific')
        },
        {
            title: 'Document Status',
            dataIndex: ['objVendorDocStatus', 'strLongDesc'],
            key: 'objVendorDocStatus'
        },
        {
            title: 'Version',
            dataIndex: 'intVersion',
            key: 'intVersion',
            render: (text, record, index) => ('(V' + record.intVersion + ')')
        },
        {
            title: 'Document Name',
            dataIndex: 'strDocName',
            key: 'strDocName'
        },
        {
            title: 'Action',
            render: (text, record, index) => (_jsxs(Space, { children: [_jsx(CommentOutlined, { onClick: () => getCommentsHistoryForDoc(record) }), record.boolPrevVerAvail || record.boolRevisedVersion ? (_jsx(UndoOutlined, { onClick: () => getPreviousVersionDocs(record, record.key) })) : ('')] }))
        }
    ];
    const DownloadAttachementsColumns = [
        {
            title: 'S.No.',
            render: (text, record, index) => index + 1
        },
        {
            title: 'Submission Date',
            dataIndex: 'dtSubmittedDate',
            key: 'dtSubmittedDate',
            render: (text, record, index) => formatDateDisplay(record.dtSubmittedDate)
        },
        {
            title: 'Document Name',
            dataIndex: 'strDocName',
            key: 'strDocName',
            render: (text, record, index) => (_jsx(Typography.Link, { onClick: () => DownloadDocument(record === null || record === void 0 ? void 0 : record.strDocRefId), children: record.strDocName }))
        },
        {
            title: 'Remarks',
            dataIndex: 'strRemarks',
            key: 'strRemarks',
        }
    ];
    const handleUpload = (fileList) => {
        const { status } = fileList.file;
        setFileList(fileList.fileList);
        if (status !== 'uploading') {
            fileList.status = 'done';
            message.success(`${fileList.file.name} ${fileList.file.status} file uploaded successfully.`);
        }
    };
    const vendorDocUploadFile = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoadingVendorDoc(true);
        let lstVendorUploadDocs = form.getFieldValue('lstVendorUploadDocs') || [];
        const newFilesPromises = fileList.map((file, index) => __awaiter(void 0, void 0, void 0, function* () {
            const formData = new FormData();
            formData.append('file', file.originFileObj); // Corrected `originFileObj` typo
            formData.append('strPathType', 'DIRECT_CERT_UPLOAD');
            const res = yield certificateService.saveDocument(formData).catch((error) => {
                var _a;
                setLoadingVendorDoc(false);
                message.error((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data);
                return;
            });
            return {
                key: lstVendorUploadDocs.length + index + 1,
                dtSubmittedDate: dayjs(new Date()).format('DD/MM/YYYY hh:mm:ss'),
                strDocName: file.name,
                strDocRefId: res,
                vendorDocs: [
                    {
                        uid: res,
                        name: file === null || file === void 0 ? void 0 : file.name,
                        url: URL.createObjectURL(file.originFileObj),
                        status: 'done'
                    }
                ]
            };
        }));
        const newFiles = yield Promise.all(newFilesPromises);
        lstVendorUploadDocs = lstVendorUploadDocs.concat(newFiles);
        form.setFieldsValue({ lstVendorUploadDocs: lstVendorUploadDocs });
        setFileList([]);
        setLoadingVendorDoc(false);
    });
    const onDownload = (file) => {
        // Example: Trigger a download for a file located at file.url
        if (file === null || file === void 0 ? void 0 : file.isDocRefId) {
            DownloadDocument(file.uid);
        }
        else {
            if (file.url) {
                const a = document.createElement('a');
                a.href = file.url;
                a.download = file.name;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
            else if (file.originFileObj) {
                // If the file is local (not yet uploaded), read it as a Blob
                const reader = new FileReader();
                reader.readAsArrayBuffer(file.originFileObj);
                reader.onload = () => {
                    const blob = new Blob([reader.result]);
                    const a = document.createElement('a');
                    a.href = URL.createObjectURL(blob);
                    a.download = file.name;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(a.href);
                };
            }
        }
    };
    const handleUploadRemove = (rowIndex, file, docType) => {
        if (docType === 'VENDOR_UPLOAD_DOCS') {
            const docList = form.getFieldValue('lstVendorUploadDocs') || [];
            certificateService.deleteDocument(docList[rowIndex]['strDocRefId']).then((res) => {
                form.resetFields([['lstVendorUploadDocs', rowIndex, 'strDocRefId']]);
            });
        }
        if (docType === 'VENDOR_CERT_DOCS') {
            const certList = form.getFieldValue('lstMpWoVendorCert') || [];
            certificateService.deleteDocument(certList[rowIndex]['strDocRefId']).then((res) => {
                form.resetFields([['lstMpWoVendorCert', rowIndex, 'strDocRefId']]);
            });
        }
        if (docType === 'VENDOR_INVOICE_DOCS') {
            const certInvoiceList = form.getFieldValue('lstMpWoVendorInvoice') || [];
            certificateService.deleteDocument(certInvoiceList[rowIndex]['strDocRefId']).then((res) => {
                form.resetFields([['lstMpWoVendorInvoice', rowIndex, 'strDocRefId']]);
            });
        }
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(true);
            }, 10);
        });
    };
    const customUploadRequest = (rowIndex_1, _a, docType_1) => __awaiter(void 0, [rowIndex_1, _a, docType_1], void 0, function* (rowIndex, { file, onSuccess, onError }, docType) {
        try {
            // Simulate a successful response
            const formData = new FormData();
            formData.append('file', file);
            formData.append('strPathType', docType);
            certificateService.saveDocument(formData).then((res) => {
                if (docType === 'VENDOR_UPLOAD_DOCS') {
                    const docList = form.getFieldValue('lstVendorUploadDocs') || [];
                    // docList[rowIndex]['validate'] = true;
                    docList[rowIndex]['strDocRefId'] = res;
                    form.setFieldsValue({ lstVendorUploadDocs: docList });
                }
                if (docType === 'VENDOR_CERT_DOCS') {
                    const certList = form.getFieldValue('lstMpWoVendorCert') || [];
                    certList[rowIndex]['strDocRefId'] = res;
                    form.setFieldsValue({ lstMpWoVendorCert: certList });
                }
                if (docType === 'VENDOR_INVOICE_DOCS') {
                    const certInvoiceList = form.getFieldValue('lstMpWoVendorInvoice') || [];
                    certInvoiceList[rowIndex]['strDocRefId'] = res;
                    form.setFieldsValue({ lstMpWoVendorInvoice: certInvoiceList });
                }
            }).catch((error) => {
                var _a;
                message.error((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data);
                return;
            });
            setTimeout(() => {
                if (onSuccess) {
                    onSuccess({ status: 'success' });
                }
            }, 10);
        }
        catch (error) {
            if (onError) {
                onError(error);
            }
            message.error('Failed to upload file.');
        }
    });
    const handleFileChange = (fileList) => {
        const { status } = fileList.file;
        if (status !== 'uploading') {
            fileList.status = 'done';
            message.success(`${fileList.file.name} ${fileList.file.status} file uploaded successfully.`);
        }
    };
    const vendorDocColumns = [
        {
            title: 'S.No.',
            width: '10%',
            dataIndex: 'key',
            key: 'key',
            render: (text, record, index) => _jsx(_Fragment, { children: record.key + 1 })
        },
        {
            title: 'Document Upload Date',
            width: '30%',
            dataIndex: 'dtSubmittedDate',
            key: 'dtSubmittedDate',
            render: (text, record, index) => (_jsx(Typography.Text, { style: inputStyle, children: formatDateDisplay(form.getFieldValue(['lstVendorUploadDocs', record.key, 'dtSubmittedDate'])) }))
        },
        {
            title: 'Document Name',
            width: '30%',
            dataIndex: 'strDocName',
            key: 'strDocName',
            render: (text, record, index) => (_jsx(Form.Item, { name: [record.key, 'vendorDocs'], valuePropName: "fileList", getValueFromEvent: normFile, rules: [
                    {
                        required: true,
                        message: 'Document is Required'
                    }
                ], children: _jsx(Upload, { className: "custom-vendor-upload", name: "files", maxCount: 1, onChange: handleFileChange, customRequest: (options) => customUploadRequest(record.key, options, 'VENDOR_UPLOAD_DOCS'), showUploadList: { showDownloadIcon: true }, onDownload: onDownload, onRemove: (file) => handleUploadRemove(record.key, file, 'VENDOR_UPLOAD_DOCS'), children: _jsx(Button, { type: "primary", icon: _jsx(UploadOutlined, {}), children: "Upload" }) }) }))
        },
        {
            title: 'Remarks',
            width: '30%',
            dataIndex: 'strRemarks',
            key: 'strRemarks',
            render: (text, record, index) => (_jsx(Form.Item, { name: [record.key, 'strRemarks'], rules: [{ required: true, message: 'Remarks are required' }], children: _jsx(TextArea, { showCount: true, maxLength: 100, placeholder: "Remarks", style: { height: 120, resize: 'none' } }) }))
        }
    ];
    const handleDocUploadDelete = (remove) => {
        remove(selectedUploadRowKeys.map((key) => parseInt(String(key))));
        setSelectedUploadRowKeys([]); // Clear selection after deletion
        form.validateFields();
    };
    const normFile = (e) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e === null || e === void 0 ? void 0 : e.fileList;
    };
    const onChangeDate = (rowIndex, fieldName, date) => {
        const certList = form.getFieldValue('lstMpWoVendorCert') || [];
        if (fieldName === 'certIssueDate') {
            if (date) {
                certList[rowIndex]['certIssueDate'] = date.add(1, 'day').format('DD-MM-YYYY');
                form.setFieldsValue({ certList });
            }
            else {
                form.resetFields([['lstMpWoVendorCert', rowIndex, 'certIssueDate']]);
            }
        }
        if (fieldName === 'certExpiredDate') {
            if (date) {
                certList[rowIndex]['certExpiredDate'] = date.subtract(1, 'day').format('DD-MM-YYYY');
                form.setFieldsValue({ certList });
            }
            else {
                form.resetFields([['lstMpWoVendorCert', rowIndex, 'certExpiredDate']]);
            }
        }
    };
    function handleOpenCertUpdateModal(certUniqueId) {
        setOpenCertUpdateModal(true);
        const objCertUpdate = {
            intUniqueCertificateId: certUniqueId,
            intVendorComapnyId: applicationData.loggedInClient.userLoginDetails.intCompanyID
        };
        subProjectService.getCertUpdateReqStatusComments(objCertUpdate).then((res) => {
            setLstCertDocumentComments(res);
        });
    }
    const certColumns = [
        {
            title: 'Factory Information',
            width: '20%',
            dataIndex: 'objProductFamily',
            render: (text, record, index) => {
                var _a, _b, _c, _d, _e, _f;
                return (_jsxs(_Fragment, { children: [_jsx(Form.Item, { name: [record.key, 'objProductFamily', 'strFactoryName'], children: _jsx(Input, { placeholder: "Factory Name", disabled: ((_a = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objLuWorkOrderStatus) === null || _a === void 0 ? void 0 : _a.intId) === 4003 ||
                                    !(((_b = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objLuWorkOrderStatus) === null || _b === void 0 ? void 0 : _b.intId) === 4050 ||
                                        ((_c = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objLuWorkOrderStatus) === null || _c === void 0 ? void 0 : _c.intId) === 4060) ||
                                    form.getFieldValue(['lstMpWoVendorCert', record.key, 'objCertStatus', 'intId']) ===
                                        4 ||
                                    form.getFieldValue([
                                        'lstMpWoVendorCert',
                                        record.key,
                                        'objLuCertVerification',
                                        'intId'
                                    ]) === 1809 ||
                                    form.getFieldValue([
                                        'lstMpWoVendorCert',
                                        record.key,
                                        'objLuCertVerification',
                                        'intId'
                                    ]) === 1805 ||
                                    form.getFieldValue([
                                        'lstMpWoVendorCert',
                                        record.key,
                                        'objLuCertVerification',
                                        'intId'
                                    ]) === 1806 ||
                                    boolDisableVenAssStatus }) }), _jsx("br", {}), _jsx(Form.Item, { name: [record.key, 'objProductFamily', 'strFactoryAddress'], children: _jsx(Input, { placeholder: "Factory Address", disabled: ((_d = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objLuWorkOrderStatus) === null || _d === void 0 ? void 0 : _d.intId) === 4003 ||
                                    !(((_e = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objLuWorkOrderStatus) === null || _e === void 0 ? void 0 : _e.intId) === 4050 ||
                                        ((_f = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objLuWorkOrderStatus) === null || _f === void 0 ? void 0 : _f.intId) === 4060) ||
                                    form.getFieldValue(['lstMpWoVendorCert', record.key, 'objCertStatus', 'intId']) ===
                                        4 ||
                                    form.getFieldValue([
                                        'lstMpWoVendorCert',
                                        record.key,
                                        'objLuCertVerification',
                                        'intId'
                                    ]) === 1809 ||
                                    form.getFieldValue([
                                        'lstMpWoVendorCert',
                                        record.key,
                                        'objLuCertVerification',
                                        'intId'
                                    ]) === 1805 ||
                                    form.getFieldValue([
                                        'lstMpWoVendorCert',
                                        record.key,
                                        'objLuCertVerification',
                                        'intId'
                                    ]) === 1806 ||
                                    boolDisableVenAssStatus }) })] }));
            }
        },
        {
            title: 'Certificate Body',
            width: '20%',
            dataIndex: 'strCertBody',
            render: (text, record, index) => {
                var _a, _b, _c;
                return (_jsx(_Fragment, { children: _jsx(Form.Item, { name: [record.key, 'strCertBody'], children: _jsx(Input, { placeholder: "Certificate Body", disabled: ((_a = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objLuWorkOrderStatus) === null || _a === void 0 ? void 0 : _a.intId) === 4003 ||
                                !(((_b = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objLuWorkOrderStatus) === null || _b === void 0 ? void 0 : _b.intId) === 4050 ||
                                    ((_c = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objLuWorkOrderStatus) === null || _c === void 0 ? void 0 : _c.intId) === 4060) ||
                                form.getFieldValue(['lstMpWoVendorCert', record.key, 'objCertStatus', 'intId']) ===
                                    4 ||
                                form.getFieldValue([
                                    'lstMpWoVendorCert',
                                    record.key,
                                    'objLuCertVerification',
                                    'intId'
                                ]) === 1809 ||
                                form.getFieldValue([
                                    'lstMpWoVendorCert',
                                    record.key,
                                    'objLuCertVerification',
                                    'intId'
                                ]) === 1805 ||
                                form.getFieldValue([
                                    'lstMpWoVendorCert',
                                    record.key,
                                    'objLuCertVerification',
                                    'intId'
                                ]) === 1806 ||
                                boolDisableVenAssStatus }) }) }));
            }
        },
        {
            title: 'Certificate ID',
            width: '20%',
            dataIndex: 'strCertId',
            render: (text, record, index) => {
                var _a, _b, _c;
                return (_jsx(_Fragment, { children: _jsx(Form.Item, { name: [record.key, 'strCertId'], rules: [
                            {
                                required: true,
                                message: ''
                                // message: 'Certificate Id is Required'
                            }
                        ], children: _jsx(Input, { placeholder: "Certificate ID", disabled: ((_a = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objLuWorkOrderStatus) === null || _a === void 0 ? void 0 : _a.intId) === 4003 ||
                                !(((_b = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objLuWorkOrderStatus) === null || _b === void 0 ? void 0 : _b.intId) === 4050 ||
                                    ((_c = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objLuWorkOrderStatus) === null || _c === void 0 ? void 0 : _c.intId) === 4060) ||
                                form.getFieldValue(['lstMpWoVendorCert', record.key, 'objCertStatus', 'intId']) ===
                                    4 ||
                                form.getFieldValue([
                                    'lstMpWoVendorCert',
                                    record.key,
                                    'objLuCertVerification',
                                    'intId'
                                ]) === 1809 ||
                                form.getFieldValue([
                                    'lstMpWoVendorCert',
                                    record.key,
                                    'objLuCertVerification',
                                    'intId'
                                ]) === 1805 ||
                                form.getFieldValue([
                                    'lstMpWoVendorCert',
                                    record.key,
                                    'objLuCertVerification',
                                    'intId'
                                ]) === 1806 ||
                                boolDisableVenAssStatus }) }) }));
            }
        },
        {
            title: 'Certificate Issue Date',
            width: '20%',
            dataIndex: 'dtCertDate',
            render: (text, record, index) => {
                var _a, _b, _c;
                return (_jsx(_Fragment, { children: _jsx(Form.Item, { name: [record.key, 'dtCertDate'], rules: [
                            {
                                required: true,
                                message: ''
                            }
                        ], children: _jsx(DatePicker, { disabled: ((_a = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objLuWorkOrderStatus) === null || _a === void 0 ? void 0 : _a.intId) === 4003 ||
                                !(((_b = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objLuWorkOrderStatus) === null || _b === void 0 ? void 0 : _b.intId) === 4050 ||
                                    ((_c = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objLuWorkOrderStatus) === null || _c === void 0 ? void 0 : _c.intId) === 4060) ||
                                form.getFieldValue(['lstMpWoVendorCert', record.key, 'objCertStatus', 'intId']) ===
                                    4 ||
                                form.getFieldValue([
                                    'lstMpWoVendorCert',
                                    record.key,
                                    'objLuCertVerification',
                                    'intId'
                                ]) === 1809 ||
                                form.getFieldValue([
                                    'lstMpWoVendorCert',
                                    record.key,
                                    'objLuCertVerification',
                                    'intId'
                                ]) === 1805 ||
                                form.getFieldValue([
                                    'lstMpWoVendorCert',
                                    record.key,
                                    'objLuCertVerification',
                                    'intId'
                                ]) === 1806 ||
                                boolDisableVenAssStatus, format: customFormat, multiple: false, onChange: (date, dateString) => onChangeDate(record.key, 'certIssueDate', date), maxDate: dayjs(form.getFieldValue(['lstMpWoVendorCert', record.key, 'certExpiredDate']), 'DD-MM-YYYY') }) }) }));
            }
        },
        {
            title: 'Certificate Expiration Date',
            width: '20%',
            dataIndex: 'dtCertExpirationDate',
            render: (text, record, index) => {
                var _a, _b, _c;
                return (_jsx(_Fragment, { children: _jsx(Form.Item, { name: [record.key, 'dtCertExpirationDate'], children: _jsx(DatePicker, { disabled: ((_a = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objLuWorkOrderStatus) === null || _a === void 0 ? void 0 : _a.intId) === 4003 ||
                                !(((_b = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objLuWorkOrderStatus) === null || _b === void 0 ? void 0 : _b.intId) === 4050 ||
                                    ((_c = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objLuWorkOrderStatus) === null || _c === void 0 ? void 0 : _c.intId) === 4060) ||
                                form.getFieldValue(['lstMpWoVendorCert', record.key, 'objCertStatus', 'intId']) ===
                                    4 ||
                                form.getFieldValue([
                                    'lstMpWoVendorCert',
                                    record.key,
                                    'objLuCertVerification',
                                    'intId'
                                ]) === 1809 ||
                                form.getFieldValue([
                                    'lstMpWoVendorCert',
                                    record.key,
                                    'objLuCertVerification',
                                    'intId'
                                ]) === 1805 ||
                                form.getFieldValue([
                                    'lstMpWoVendorCert',
                                    record.key,
                                    'objLuCertVerification',
                                    'intId'
                                ]) === 1806 ||
                                boolDisableVenAssStatus, format: customFormat, multiple: false, onChange: (date, dateString) => onChangeDate(record.key, 'certExpiredDate', date), minDate: dayjs(form.getFieldValue(['lstMpWoVendorCert', record.key, 'certIssueDate']), 'DD-MM-YYYY') }) }) }));
            }
        },
        {
            title: 'Certificate Document',
            width: '20%',
            dataIndex: 'strDocName',
            render: (text, record, index) => (_jsx(_Fragment, { children: true ||
                    ((form.getFieldValue([
                        'lstMpWoVendorCert',
                        record.key,
                        'objLuCertVerification',
                        'intId'
                    ]) === 1808 ||
                        form.getFieldValue([
                            'lstMpWoVendorCert',
                            record.key,
                            'objLuCertVerification',
                            'intId'
                        ]) === 1807) &&
                        !boolDisableVenAssStatus) ? (_jsx(Form.Item, { name: [record.key, 'certUpload'], valuePropName: "fileList", getValueFromEvent: normFile, rules: [
                        {
                            required: true,
                            message: 'Required'
                        }
                    ], children: _jsx(Upload, { className: "custom-upload", name: "files", maxCount: 1, onChange: handleFileChange, customRequest: (options) => customUploadRequest(record.key, options, 'VENDOR_CERT_DOCS'), showUploadList: { showDownloadIcon: true }, onDownload: onDownload, onRemove: (file) => handleUploadRemove(record.key, file, 'VENDOR_CERT_DOCS'), children: _jsx(Button, { type: "primary", icon: _jsx(UploadOutlined, {}), children: "Upload" }) }) })) : (_jsx(Typography.Link, { onClick: () => DownloadDocument(form.getFieldValue(['lstMpWoVendorCert', record.key, 'strDocRefId'])), children: form.getFieldValue(['lstMpWoVendorCert', record.key, 'strDocName']) })) }))
        },
        {
            title: 'Received Date',
            width: '20%',
            dataIndex: 'dtCreatedDate',
            render: (text, record, index) => (_jsx(_Fragment, { children: formatDateDisplay(form.getFieldValue(['lstMpWoVendorCert', record.key, 'dtCreatedDate'])) }))
        },
        {
            title: 'Certificate Status',
            width: '20%',
            dataIndex: 'objCertStatus',
            render: (text, record, index) => (_jsx(_Fragment, { children: form.getFieldValue(['lstMpWoVendorCert', record.key, 'objCertStatus', 'strLongDesc']) }))
        },
        {
            title: 'Verification Status',
            width: '20%',
            dataIndex: 'objLuCertVerification',
            render: (text, record, index) => (_jsxs(_Fragment, { children: [form.getFieldValue([
                        'lstMpWoVendorCert',
                        record.key,
                        'objLuCertVerification',
                        'strLongDesc'
                    ]), form.getFieldValue([
                        'lstMpWoVendorCert',
                        record.key,
                        'objLuCertVerification',
                        'intId'
                    ]) === 1807 &&
                        _jsxs(Typography.Link, { onClick: (e) => handleOpenCertUpdateModal(form.getFieldValue(['lstMpWoVendorCert', record.key, 'intId'])), children: [_jsx("br", {}), "View Details"] })] }))
        }
    ];
    const handleInvoiceDelete = (remove) => {
        remove(selectedInvoiceRowKeys.map((key) => parseInt(String(key))));
        setSelectedInvoiceRowKeys([]); // Clear selection after deletion
        form.validateFields();
    };
    const invoiceColumns = [
        {
            title: 'Invoice Due Date',
            width: '20%',
            dataIndex: 'dtInvoiceDueDate',
            render: (text, record, index) => (_jsx(_Fragment, { children: _jsx(Form.Item, { name: [record.key, 'dtInvoiceDueDate'], children: _jsx(DatePicker, { style: inputStyle, format: customFormat, multiple: false }) }) }))
        },
        {
            title: 'Invoice Received Date',
            width: '20%',
            dataIndex: 'dtReceivedDate',
            render: (text, record, index) => (_jsx(_Fragment, { children: _jsx(Form.Item, { name: [record.key, 'dtReceivedDate'], rules: [
                        {
                            required: true,
                            message: ''
                        }
                    ], children: _jsx(DatePicker, { style: inputStyle, format: customFormat, multiple: false }) }) }))
        },
        {
            title: 'Invoice Document',
            width: '15%',
            dataIndex: 'strDocName',
            render: (text, record, index) => (_jsx(_Fragment, { children: _jsx(Form.Item, { name: [record.key, 'invoiceUpload'], valuePropName: "fileList", getValueFromEvent: normFile, rules: [
                        {
                            required: true,
                            message: 'Required'
                        }
                    ], children: _jsx(Upload, { style: inputStyle, className: "custom-upload", name: "files", maxCount: 1, onChange: handleFileChange, customRequest: (options) => customUploadRequest(record.key, options, 'VENDOR_INVOICE_DOCS'), showUploadList: { showDownloadIcon: true }, onDownload: onDownload, onRemove: (file) => handleUploadRemove(record.key, file, 'VENDOR_INVOICE_DOCS'), children: _jsx(Button, { type: "primary", icon: _jsx(UploadOutlined, {}), children: "Upload" }) }) }) }))
        },
        {
            title: 'Invoice No.',
            width: '20%',
            dataIndex: 'strInvoiceId',
            render: (text, record, index) => (_jsx(_Fragment, { children: _jsx(Form.Item, { name: [record.key, 'strInvoiceId'], children: _jsx(Input, { style: inputStyle, placeholder: "Invoice Number" }) }) }))
        },
        {
            title: 'Invoice Amount',
            width: '15%',
            dataIndex: 'fltInvoidAmount',
            render: (text, record, index) => (_jsx(_Fragment, { children: _jsx(Form.Item, { name: [record.key, 'fltInvoidAmount'], children: _jsx(InputNumber, { style: inputStyle, placeholder: "Invoice Amount", min: 0, step: 0.01, precision: 2 }) }) }))
        },
        {
            title: 'Currency',
            width: '20%',
            dataIndex: 'objLuCurrency',
            render: (text, record, index) => (_jsx(_Fragment, { children: _jsx(Form.Item, { name: [record.key, 'objLuCurrency', 'intId'], children: _jsx(Select, { style: inputStyle, showSearch: true, filterOption: (input, option) => { var _a; return ((_a = option === null || option === void 0 ? void 0 : option.label) !== null && _a !== void 0 ? _a : '').toLowerCase().includes(input.toLowerCase()); }, placeholder: "Currency", options: optCurrency }) }) }))
        },
        {
            title: 'Remittance Advice',
            width: '15%',
            dataIndex: 'strRemittanceDocName',
            render: (text, record, index) => (_jsx(Typography.Link, { onClick: () => DownloadDocument(form.getFieldValue(['lstMpWoVendorInvoice', record.key, 'strRemittanceDocRefId'])), children: form.getFieldValue(['lstMpWoVendorInvoice', record.key, 'strRemittanceDocName']) }))
        },
        {
            title: 'Verification Status',
            width: '10%',
            dataIndex: 'objLuCertVerification',
            render: (text, record, index) => (_jsx(_Fragment, { children: form.getFieldValue([
                    'lstMpWoVendorInvoice',
                    record.key,
                    'objLuCertVerification',
                    'strLongDesc'
                ]) }))
        }
    ];
    const byteArrayToBlob = (byteArray) => {
        const uint8Array = new Uint8Array(byteArray);
        return new Blob([uint8Array], { type: 'application/pdf' });
    };
    const getAllDocuments = () => __awaiter(void 0, void 0, void 0, function* () {
        setDownAllloading(true);
        const zip = new JSZip();
        let listDocDownload = [];
        if (objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.lstEEDocumentDownload) {
            listDocDownload = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.lstEEDocumentDownload.filter((item, index) => selectedDownloadRowKeys.includes(index));
        }
        subProjectService.getAllDocument(listDocDownload).then((res) => {
            if (res.length != 0) {
                res.forEach((file) => {
                    const blob = byteArrayToBlob(file.bytefileData);
                    zip.file(file.strDocName, blob);
                });
                zip.generateAsync({ type: 'blob' }).then((content) => {
                    saveAs(content, 'DownloadAll.zip');
                    setDownAllloading(false);
                });
            }
            else {
                message.error('No documents Available to download');
                setDownAllloading(false);
            }
            setDownAllloading(false);
        });
    });
    const acceptRejectDoc = (type) => {
        setLoading(true);
        const objLastUpdatedBy = {
            objUser: {
                strLongDesc: applicationData.loggedInClient.userLoginDetails.strCompanyName + ' [Vendor]'
            }
        };
        let listDocReq = [];
        if (objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.lstAttachements) {
            listDocReq = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.lstAttachements.filter((item, index) => selectedDocRowKeys.includes(index)).map((item, index) => {
                return Object.assign(Object.assign({}, item), { intVendorId: applicationData.loggedInClient.userLoginDetails.intCompanyID, strWorkOrderId: objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.strWorkOrderId, objLastUpdatedBy: objLastUpdatedBy, boolAcceptDocs: type === 'ACCEPT' ? true : false, boolDontAcceptDocs: type === 'REJECT' ? true : false });
            });
        }
        const objWo = Object.assign({}, objWorkOrder);
        let docsMap = {};
        docsMap['WoDocs'] = JSON.stringify(listDocReq);
        docsMap['Action'] = JSON.stringify(type);
        docsMap['WoDetails'] = JSON.stringify(objWo);
        docsMap['UserDetail'] = JSON.stringify(objLastUpdatedBy);
        subProjectService.saveWoVenDocStatus(docsMap).then((res) => {
            var _a, _b, _c, _d;
            setLoading(false);
            setSelectedDocRowKeys([]);
            if (type === 'ACCEPT') {
                message.success('Document Accepted successfully');
                commonService
                    .logUserActivity((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId, UserActivity.VP__Sub_Project_Detail_Doc_Accept);
            }
            if (type === 'REJECT') {
                message.success('Document Rejected successfully');
                commonService
                    .logUserActivity((_d = (_c = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _c === void 0 ? void 0 : _c.userLoginDetails) === null || _d === void 0 ? void 0 : _d.strUserEmailId, UserActivity.VP__Sub_Project_Detail_Doc_Reject);
            }
            directCertManipulate(res);
        });
    };
    const onFinishFailed = (errorInfo) => {
        message.error('Please fill in all mandatory fields in the Upload Document, Certificate Information, and Invoice Information forms.');
        setLoading(false);
    };
    const onFinish = (values) => {
        var _a, _b;
        setLoading(true);
        const lstMpWoVendorValidCert = form.getFieldValue('lstMpWoVendorCert');
        let validateCert = false;
        if (lstMpWoVendorValidCert && lstMpWoVendorValidCert.length > 0) {
            lstMpWoVendorValidCert.map((item) => {
                if (item.dtCertDate) {
                    validateCert = true;
                }
                return Object.assign({}, item);
            });
        }
        else {
            validateCert = true;
        }
        if (validateCert) {
            let certList = [];
            if (lstMpWoVendorValidCert) {
                certList = lstMpWoVendorValidCert.map((item, index) => {
                    var _a, _b, _c;
                    if (item.objLuCertVerification &&
                        ((_a = item.objLuCertVerification) === null || _a === void 0 ? void 0 : _a.intId) &&
                        (((_b = item.objLuCertVerification) === null || _b === void 0 ? void 0 : _b.intId) === 1808 ||
                            ((_c = item.objLuCertVerification) === null || _c === void 0 ? void 0 : _c.intId) === 1807)) {
                        return Object.assign(Object.assign({}, item), { dtCertDate: (item === null || item === void 0 ? void 0 : item.dtCertDate) ? formatDate(new Date(item === null || item === void 0 ? void 0 : item.dtCertDate)) : null, dtCertExpirationDate: (item === null || item === void 0 ? void 0 : item.dtCertExpirationDate)
                                ? formatDate(new Date(item === null || item === void 0 ? void 0 : item.dtCertExpirationDate))
                                : null, objLuCertVerification: { intId: 1805, strLongDesc: 'Received' }, dtCreatedDate: formatDate(new Date()), objMpWoVendor: {
                                objTblVendorCompany: {
                                    intVendorId: applicationData.loggedInClient.userLoginDetails.intCompanyID
                                }
                            }, certUpload: null });
                    }
                    else {
                        return Object.assign(Object.assign({}, item), { dtCertDate: (item === null || item === void 0 ? void 0 : item.dtCertDate) ? formatDate(new Date(item === null || item === void 0 ? void 0 : item.dtCertDate)) : null, dtCertExpirationDate: (item === null || item === void 0 ? void 0 : item.dtCertExpirationDate)
                                ? formatDate(new Date(item === null || item === void 0 ? void 0 : item.dtCertExpirationDate))
                                : null, dtCreatedDate: (item === null || item === void 0 ? void 0 : item.dtCreatedDate) ? formatDate(new Date(item === null || item === void 0 ? void 0 : item.dtCreatedDate)) : null, certUpload: null });
                    }
                });
            }
            const lstMpWoVendorInvoiceValidCert = form.getFieldValue('lstMpWoVendorInvoice');
            let certInvoiceList = [];
            if (lstMpWoVendorInvoiceValidCert) {
                certInvoiceList = lstMpWoVendorInvoiceValidCert.map((item, index) => (Object.assign(Object.assign({}, item), { dtCreatedDate: (item === null || item === void 0 ? void 0 : item.dtCreatedDate) ? formatDate(new Date(item === null || item === void 0 ? void 0 : item.dtCreatedDate)) : null, dtInvoiceDueDate: (item === null || item === void 0 ? void 0 : item.dtInvoiceDueDate)
                        ? formatDate(new Date(item === null || item === void 0 ? void 0 : item.dtInvoiceDueDate))
                        : null, dtReceivedDate: (item === null || item === void 0 ? void 0 : item.dtReceivedDate) ? formatDate(new Date(item === null || item === void 0 ? void 0 : item.dtReceivedDate)) : null, objMpWoVendor: {
                        objTblVendorCompany: {
                            intVendorId: applicationData.loggedInClient.userLoginDetails.intCompanyID
                        }
                    }, invoiceUpload: null })));
            }
            const lstlstVendorUploadDocsValidCert = form.getFieldValue('lstVendorUploadDocs');
            let lstVendorUploadDocs = [];
            if (lstlstVendorUploadDocsValidCert) {
                lstVendorUploadDocs = lstlstVendorUploadDocsValidCert.map((item, index) => (Object.assign(Object.assign({}, item), { dtSubmittedDate: item === null || item === void 0 ? void 0 : item.dtSubmittedDate, 
                    // dtSubmittedDate: item?.dtSubmittedDate && !isNaN(Date.parse(item?.dtSubmittedDate))
                    //   ? formatDate(new Date(item?.dtSubmittedDate))
                    //   : null,
                    vendorDocs: null })));
            }
            const objLastUpdatedBy = {
                objUser: {
                    strLongDesc: applicationData.loggedInClient.userLoginDetails.strCompanyName + ' [Vendor]'
                }
            };
            const objSaveWorkOrder = Object.assign({}, objWorkOrder);
            objSaveWorkOrder['dtVendorPlannedCompDate'] = formatDate(values === null || values === void 0 ? void 0 : values.dtVendorPlannedCompDate);
            objSaveWorkOrder['dtVendorAssignedDate'] = formatDate(new Date(values === null || values === void 0 ? void 0 : values.dtVendorAssignedDate));
            objSaveWorkOrder['intVendorId'] =
                applicationData.loggedInClient.userLoginDetails.intCompanyID;
            objSaveWorkOrder['objLastUpdatedBy'] = objLastUpdatedBy;
            objSaveWorkOrder['dtSampleReceivedDate'] = (values === null || values === void 0 ? void 0 : values.dtSampleReceivedDate)
                ? formatDate(new Date(values === null || values === void 0 ? void 0 : values.dtSampleReceivedDate))
                : null;
            objSaveWorkOrder['lstMpWoVendorCert'] = certList;
            objSaveWorkOrder['lstMpWoVendorInvoice'] = certInvoiceList;
            objSaveWorkOrder['lstVendorUploadDocs'] = lstVendorUploadDocs;
            subProjectService.saveWorkOrderVendor(objSaveWorkOrder).then((res) => {
                setLoading(false);
                directCertManipulate(res);
                CertVendorSuccess();
            });
            commonService
                .logUserActivity((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId, UserActivity.VP__Sub_Project_Detail_Save);
        }
        else {
            message.error('Please fill in all mandatory fields in the Upload Document, Certificate Information, and Invoice Information forms.');
            setLoading(false);
        }
    };
    const CertVendorSuccess = () => {
        message.success('Saved successfully.');
    };
    const contentList = [
        {
            title: 'Sub Project Information',
            content: (_jsxs(_Fragment, { children: [_jsx(Descriptions, { title: 'Certificate Information', bordered: true, column: { xs: 1, sm: 2, md: 3, lg: 3, xl: 4, xxl: 4 }, items: loadingDesc ? loadingItems : subProjectInfo }), _jsx(Divider, {}), _jsx(Descriptions, { title: 'Service & Product Information', extra: _jsx(Flex, { justify: 'flex-end', children: _jsx(Alert, { message: "Note: Please refer to test reports & product specification for correct description", type: "error" }) }), bordered: true, column: { xs: 1, sm: 2, md: 3, lg: 3, xl: 4, xxl: 4 }, items: loadingDesc ? loadingItems : serviceProductInfo }), _jsx(Divider, {}), _jsx(Descriptions, { title: 'Sub Project Schedule', bordered: true, column: { xs: 1, sm: 2, md: 3, lg: 3, xl: 4, xxl: 4 }, items: loadingDesc ? loadingItems : prjScheduleInfo }), _jsx(Divider, {}), _jsx(Descriptions, { title: 'Sample Information', bordered: true, column: { xs: 1, sm: 2, md: 3, lg: 3, xl: 4, xxl: 4 }, items: loadingDesc ? loadingItems : sampleInfo }), _jsx(Divider, {}), ((_12 = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objTblService) === null || _12 === void 0 ? void 0 : _12.lstMpServiceSampleInfos) &&
                        ((_14 = (_13 = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objTblService) === null || _13 === void 0 ? void 0 : _13.lstMpServiceSampleInfos) === null || _14 === void 0 ? void 0 : _14.length) !== 0 &&
                        objWorkOrder.intTestingApplicability === 1 && (_jsx(Table, { scroll: {
                            x: 1400
                        }, columns: sampleInfosColumns, dataSource: (_16 = (_15 = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objTblService) === null || _15 === void 0 ? void 0 : _15.lstMpServiceSampleInfos) === null || _16 === void 0 ? void 0 : _16.map((item, index) => (Object.assign(Object.assign({}, item), { key: item.id || index // Ensure each item has a unique key
                         }))), pagination: { position: ['bottomLeft'], defaultPageSize: 10 } })), (objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.lstWoVendorServiceRating) &&
                        ((_17 = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.lstWoVendorServiceRating) === null || _17 === void 0 ? void 0 : _17.length) !== 0 && (_jsx(Table, { scroll: {
                            x: 1400
                        }, columns: vendorServiceRatingColumns, dataSource: (_18 = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.lstWoVendorServiceRating) === null || _18 === void 0 ? void 0 : _18.map((item, index) => (Object.assign(Object.assign({}, item), { key: item.id || index // Ensure each item has a unique key
                         }))), pagination: { position: ['bottomLeft'], defaultPageSize: 10 } })), _jsx(Divider, {}), _jsx(Descriptions, { title: 'BV Contact', extra: _jsx(Flex, { justify: 'flex-end', children: _jsx(Alert, { message: _jsxs(_Fragment, { children: ["Click", ' ', _jsx(Typography.Link, { onClick: () => getBVComments(), children: "\u00A0here\u00A0" }), ' ', "to share comments with BV"] }), type: "success" }) }), bordered: true, column: { xs: 1, sm: 2, md: 3, lg: 3, xl: 4, xxl: 4 }, items: loadingDesc ? loadingItems : bvContactInfo })] }))
        },
        {
            title: 'View Document List',
            content: (_jsxs(_Fragment, { children: [_jsx(Table, { scroll: {
                            x: 1400
                        }, rowSelection: {
                            type: 'checkbox',
                            selectedRowKeys: selectedDocRowKeys,
                            onChange: (selectedRowKeys, selectedRows, info) => {
                                onSelectChange('acceptDocAttachment', selectedRowKeys);
                            },
                            getCheckboxProps: (record) => ({
                                disabled: record.boolDisableDocRow
                            })
                        }, columns: attachementsColumns, dataSource: (_19 = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.lstAttachements) === null || _19 === void 0 ? void 0 : _19.map((item, index) => (Object.assign(Object.assign({}, item), { key: index // Ensure each item has a unique key
                         }))), pagination: { position: ['bottomLeft'], defaultPageSize: 10 } }), boolDisableWoDocsBtn &&
                        !(((_20 = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objLuWorkOrderStatus) === null || _20 === void 0 ? void 0 : _20.intId) === 4004 ||
                            ((_21 = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objLuWorkOrderStatus) === null || _21 === void 0 ? void 0 : _21.intId) == 4005 ||
                            ((_22 = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objLuWorkOrderStatus) === null || _22 === void 0 ? void 0 : _22.intId) == 4006) &&
                        !boolDisableVenAssStatus ? (_jsxs(Space, { size: [20, 0], wrap: true, children: [_jsx(Button, { type: "primary", onClick: () => acceptRejectDoc('ACCEPT'), children: "Accept" }), _jsx(Button, { type: "primary", onClick: () => acceptRejectDoc('REJECT'), children: "Reject" })] })) : ('')] }))
        },
        {
            title: 'Download Document',
            content: (_jsxs(_Fragment, { children: [_jsx(Button, { type: "primary", onClick: getAllDocuments, loading: downAllloading, disabled: !(selectedDownloadRowKeys.length > 0), children: "Download All Document" }), _jsx(Divider, {}), _jsx(Table, { scroll: {
                            x: 1400
                        }, rowSelection: {
                            type: 'checkbox',
                            selectedRowKeys: selectedDownloadRowKeys,
                            onChange: (selectedRowKeys, selectedRows, info) => {
                                onSelectChange('downloadAttachment', selectedRowKeys);
                            }
                        }, columns: DownloadAttachementsColumns, dataSource: (_23 = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.lstEEDocumentDownload) === null || _23 === void 0 ? void 0 : _23.map((item, index) => (Object.assign(Object.assign({}, item), { key: index // Ensure each item has a unique key
                         }))), pagination: { position: ['bottomLeft'], defaultPageSize: 10 } })] }))
        },
        {
            title: 'Upload Document',
            content: (_jsxs(_Fragment, { children: [_jsxs(Space, { direction: "vertical", children: [_jsx(Flex, { justify: 'flex-start', children: _jsx(Alert, { message: "Note: It is mandatory to provide remarks for the uploaded documents. Upload of\n              documents will be complete on click of \u2018Save\u2019 button after entering remarks.", type: "error" }) }), _jsxs(Upload.Dragger, { name: "files", accept: 'application/pdf,application/x-zip-compressed', multiple: true, fileList: fileList, onChange: handleUpload, beforeUpload: () => false, listType: "text", className: "custom-vendor-upload", children: [_jsx("p", { className: "ant-upload-drag-icon", children: _jsx(InboxOutlined, {}) }), _jsx("p", { className: "ant-upload-text", children: "Click or drag file to this area to upload" }), _jsx("p", { className: "ant-upload-hint", children: "Support for multiple uploads." })] }), _jsx(Button, { type: "primary", onClick: vendorDocUploadFile, loading: loadingVendorDoc, children: "Upload" })] }), _jsx(Form.List, { name: "lstVendorUploadDocs", children: (fields, { add, remove }) => (_jsxs(_Fragment, { children: [_jsx(Table, { scroll: {
                                        x: 1400
                                    }, title: () => _jsx(Typography.Title, { level: 4, children: "Summary" }), size: "small", columns: vendorDocColumns, rowSelection: {
                                        type: 'checkbox',
                                        selectedRowKeys: selectedUploadRowKeys,
                                        onChange: (selectedRowKeys, selectedRows, info) => {
                                            onSelectChange('vendorUpload', selectedRowKeys);
                                        }
                                    }, dataSource: fields.map((field, index) => (Object.assign(Object.assign({}, field), { key: index }))), pagination: { position: ['bottomLeft'], defaultPageSize: 10 } }), _jsx("br", {}), fields.length > 0 ? (_jsx(Button, { style: { width: '75px' }, type: "primary", 
                                    // onClick={() => handleDocUploadDelete('lstVendorUploadDocs')}>
                                    onClick: () => handleDocUploadDelete(remove), children: "Delete" })) : ('')] })) })] }))
        },
        {
            title: 'Certificate Information',
            content: (_jsx(_Fragment, { children: _jsx(Form.List, { name: "lstMpWoVendorCert", children: (fields, { add, remove }) => (_jsx(Table, { scroll: {
                            x: 1400
                        }, size: "small", columns: certColumns, dataSource: fields.map((field, index) => ({ key: index })), pagination: { position: ['bottomLeft'], defaultPageSize: 10 } })) }) }))
        },
        {
            title: 'Invoice Information',
            content: (_jsx(_Fragment, { children: _jsx(Form.List, { name: "lstMpWoVendorInvoice", children: (fields, { add, remove }) => (_jsxs(_Fragment, { children: [_jsxs(Space, { size: [20, 0], wrap: true, children: [_jsx(Button, { style: { width: '75px' }, type: "primary", onClick: () => add({ objLuCertVerification: { intId: 1801, strLongDesc: 'Received' } }), children: "Add" }), _jsx(Button, { style: { width: '75px' }, type: "primary", onClick: () => handleInvoiceDelete(remove), children: "Delete" })] }), _jsx(Divider, {}), _jsx(Table, { scroll: {
                                    x: 1400
                                }, size: "small", columns: invoiceColumns, rowSelection: {
                                    type: 'checkbox',
                                    selectedRowKeys: selectedInvoiceRowKeys,
                                    onChange: (selectedRowKeys, selectedRows, info) => {
                                        onSelectChange('invoiceInfo', selectedRowKeys);
                                    }
                                }, dataSource: fields.map((field, index) => (Object.assign(Object.assign({}, field), { key: index }))), pagination: { position: ['bottomLeft'], defaultPageSize: 10 } })] })) }) }))
        }
    ];
    const handleInputChange = (type, value) => {
        if (type === 'docComments') {
            setDocQuestion(value);
        }
        if (type === 'ShareComments') {
            setBVQuestion(value);
        }
    };
    const submitDocCommentQuery = (record) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        setLoading(true);
        const objComment = {
            intVendorComapnyId: applicationData.loggedInClient.userLoginDetails.intCompanyID,
            intCommentLevelId: 4,
            intDocumentId: record.intDocId,
            intVersion: record.intVersion,
            strProjectId: record.boolGeneralDoc ? (_a = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objEEMaster) === null || _a === void 0 ? void 0 : _a.strProjectId : null,
            strWorkOrderId: objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.strWorkOrderId,
            strSourceName: 'VENDOR',
            strDocumentName: record.strDocName ? record.strDocName : '',
            strCommentDesc: docQuestion,
            strCommentByName: applicationData.loggedInClient.userLoginDetails.strCompanyName,
            strAssigneeName: objWorkOrder.objAssignedTo &&
                ((_b = objWorkOrder.objAssignedTo) === null || _b === void 0 ? void 0 : _b.objUser) &&
                ((_d = (_c = objWorkOrder.objAssignedTo) === null || _c === void 0 ? void 0 : _c.objUser) === null || _d === void 0 ? void 0 : _d.strLongDesc)
                ? (_f = (_e = objWorkOrder.objAssignedTo) === null || _e === void 0 ? void 0 : _e.objUser) === null || _f === void 0 ? void 0 : _f.strLongDesc
                : '',
            strToMailIds: objWorkOrder.objAssignedTo &&
                ((_g = objWorkOrder.objAssignedTo) === null || _g === void 0 ? void 0 : _g.objContact) &&
                ((_j = (_h = objWorkOrder.objAssignedTo) === null || _h === void 0 ? void 0 : _h.objContact) === null || _j === void 0 ? void 0 : _j.strEmailAddress)
                ? (_l = (_k = objWorkOrder.objAssignedTo) === null || _k === void 0 ? void 0 : _k.objContact) === null || _l === void 0 ? void 0 : _l.strEmailAddress
                : ''
        };
        subProjectService.saveVendorDocComment(objComment).then((res) => {
            message.success('Comment saved successfully');
            setOpenDocCommentDialog(false);
            setLoading(false);
        });
    };
    const submitBVCommentQuery = () => {
        var _a, _b, _c, _d, _e, _f;
        setLoading(true);
        const objComment = {
            strWorkOrderId: objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.strWorkOrderId,
            strWeeklyStatusComments: bvQuestion,
            intVendorId: applicationData.loggedInClient.userLoginDetails.intCompanyID,
            strVendorName: applicationData.loggedInClient.userLoginDetails.strCompanyName,
            objAssignedTo: objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objAssignedTo,
            strAction: 'Vendor',
            objEEMaster: {
                strPrimaryModel: (_a = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objEEMaster) === null || _a === void 0 ? void 0 : _a.strPrimaryModel,
                objBrandName: {
                    strLongDesc: ((_b = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objEEMaster) === null || _b === void 0 ? void 0 : _b.objBrandName)
                        ? (_d = (_c = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objEEMaster) === null || _c === void 0 ? void 0 : _c.objBrandName) === null || _d === void 0 ? void 0 : _d.strLongDesc
                        : ''
                },
                objResponsiblePerson: (_e = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objEEMaster) === null || _e === void 0 ? void 0 : _e.objResponsiblePerson
            },
            objTblService: {
                strServiceName: (_f = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objTblService) === null || _f === void 0 ? void 0 : _f.strServiceName
            },
            lstMpWoVendor: objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.lstMpWoVendor
        };
        subProjectService.saveComment(objComment).then((res) => {
            message.success('Comment saved successfully');
            setOpenBVCommentDialog(false);
            setLoading(false);
        });
    };
    return (_jsxs(Form, { form: form, layout: "vertical", name: "subProject-form", scrollToFirstError: true, onFinish: onFinish, onFinishFailed: onFinishFailed, children: [_jsx(ProductFamilyModal, { open: openProdFamilyDialog, onClose: () => setOpenProdFamilyDialog(false), productFamilyList: productFamilyList, isRemark: showFactoryRemark }), _jsx(DocComments, { data: docRecord, lstCmts: lstDocumentComments, open: openDocCommentDialog, onClose: () => setOpenDocCommentDialog(false), handleInputChange: handleInputChange, question: docQuestion, submitDocCommentQuery: submitDocCommentQuery }), _jsx(DocRevised, { data: docPrevRecord, lstCmts: lstPrevVersionDocs, open: openDocPreviousDialog, onClose: () => setOpenDocPreviousDialog(false) }), _jsx(ShareComments, { lstCmts: lstDocumentComments, open: openBVCommentDialog, onClose: () => setOpenBVCommentDialog(false), handleInputChange: handleInputChange, question: bvQuestion, submitBVCommentQuery: submitBVCommentQuery }), _jsx(CertComments, { lstCmts: lstCertDocumentComments, open: openCertUpdateModal, onClose: () => setOpenCertUpdateModal(false) }), _jsx(Card, { title: loadingDesc ? (_jsx(Skeleton.Input, { size: 'small' })) : (`${objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.strWorkOrderId} (${(_24 = objWorkOrder === null || objWorkOrder === void 0 ? void 0 : objWorkOrder.objLuWorkOrderStatus) === null || _24 === void 0 ? void 0 : _24.strLongDesc})`), extra: boolDisableVenAssStatus &&
                    _jsx(Alert, { message: "No further updates are allowed for this sub project. Please contact BV for details.", type: "error" }), children: _jsxs(Spin, { tip: "Loading...", size: "large", spinning: loading, children: [_jsx(Tabs, { type: "line", defaultActiveKey: "1", size: 'large', style: { marginBottom: 32 }, items: contentList.map((_, i) => {
                                const id = String(i + 1);
                                return {
                                    label: _.title,
                                    key: id,
                                    children: _.content
                                };
                            }) }), _jsx(Flex, { justify: "center", children: _jsx(Form.Item, { children: _jsx(Button, { type: "primary", htmlType: "submit", children: "Save Changes" }) }) })] }) })] }));
};
export default SubProjectDetail;
